import React from 'react';
import styles from '../components/Menu.css';

const BuildNumber = () => (
  <p className={styles.menuListItemHidden}>(Build 4d0034ca58fd10fdde4618aebe802ee72fdafdc2)</p>
);

export default BuildNumber;



// WEBPACK FOOTER //
// ./src/assets/BuildNumber.jsx